import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../lib/api";
import SEO from "../components/SEO.jsx";
import { seoPresets } from "../seoPresets";

export default function ForgotPassword() {
  const seo = seoPresets["/forgot-password"];
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    if (loading) return;
    setErr("");
    setLoading(true);
    try {
      await apiFetch("/api/auth/reset-init", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } catch (e) {
      setErr(e.message || "Could not send reset link.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        image={seo.openGraph?.image}
        jsonLd={seo.jsonLd}
        ogType={seo.openGraph?.type || "website"}
        twitterCard={seo.twitter?.card || "summary_large_image"}
        robots="noindex, nofollow"
      />
    <div className="auth-wrap">
      <style>{css}</style>
      <div className="auth-card">
        {sent ? (
          <>
            <h2>Check your email</h2>
            <p>We’ve sent a password reset link to <b>{email}</b>.</p>
            <button className="btn" onClick={() => navigate("/login")}>
              Back to Login
            </button>
          </>
        ) : (
          <>
            <h2>Forgot password?</h2>
            <p>Enter your email and we’ll send you a reset link.</p>
            <form onSubmit={submit}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
              {err && <div className="error">{err}</div>}
              <button className="btn primary" disabled={loading}>
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
    </>
  );
}

const css = `
.auth-wrap {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #f7f9fc;
}
.auth-card {
  background: #fff;
  padding: 28px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,.08);
  width: 100%;
  max-width: 420px;
  text-align: center;
}
.auth-card h2 {
  margin-top: 0;
}
input {
  width: 100%;
  padding: 12px;
  border: 1px solid #d6d9e0;
  border-radius: 10px;
  margin-bottom: 14px;
  font-size: 15px;
}
input:focus {
  outline: none;
  border-color: #6E5BFF;
  box-shadow: 0 0 0 4px rgba(110,91,255,.15);
}
.error {
  color: #b91c1c;
  font-size: 13px;
  margin-bottom: 8px;
}
.btn {
  border: none;
  background: linear-gradient(90deg,#6E5BFF,#A78BFA);
  color: #fff;
  padding: 12px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
}
`;
